<template>
  <div v-if="['themeKY28'].includes(THEME)" class="download-app">
    <img class="close" src="/images/download_app_close.png" alt="" @click="close">
    <img class="logo" src="/images/download_app_logo.png" alt="">
    <img class="content" src="/images/download_app_content.png" alt="">
    <div class="btn" @click="downloadApp">{{ mb_t('立即下载') }}</div>
  </div>
  <div v-if="['themeKYMN'].includes(THEME)" class="download-app">
    <div class="close-wrap">
      <img class="close" src="/images/close-bold.svg" alt="" @click="close">
    </div>
    <img class="content" src="/images/download_app_content2.jpg" alt="">
    <div class="btn-wrap">
      <div class="btn" @click="downloadApp">{{ mb_t('立即下载') }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
// import { defineEmits } from 'vue'
import { useHot } from '/@/kernel-mn/stores/useHot';
import { recordAFEvent } from '/@/plugins/appsFlyer';
import { mb_t } from '/@/plugins/global';
import { useInstall } from '/@/plugins/install_utils';
import { isIOS } from '/@/kernel-mn/utils';

const { downAppByClipboard } = useInstall();

const emit = defineEmits(['close'])

const recordAFDownloadEvent = () => {
  recordAFEvent('download_app', {
    download_type: 'link'
  })
}

const { hotData: { tenantInfo } } = useHot();

const downloadApp = e => {
  // recordAFDownloadEvent();
  // downAppByClipboard(e);
  let downUrl
  if (isIOS()) {
        // ios的下载地址
        downUrl = tenantInfo.value.tenant.app_reg_addr;
      } else {
        // android的下载地址
        downUrl = tenantInfo.value.tenant.official_addr;
      }
  window.open(downUrl);

}

const close = () => emit('close')
</script>

<style scoped lang="scss">
.download-app {
  width: 100%;
  height: px2rem(56);
  background: url(publicImgUrl('download_app_bg.png')) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .close {
    width: px2rem(24);
    height: px2rem(24);
  }

  .logo {
    width: px2rem(78);
    height: px2rem(32);
  }

  .content {
    width: px2rem(145);
    height: px2rem(40);
  }

  .btn {
    width: px2rem(82);
    height: px2rem(36);
    box-shadow: 0px 4px 10px 0px #FF000026;
    background: #FF3F3F;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: px2rem(14);
    border-radius: px2rem(8);
  }
}

.themeKYMN {
  .download-app {
    background: #2a2319;
    height: px2rem(44);
  }

  .close-wrap {
    width: px2rem(44);
    height: px2rem(44);
    background: #37332c;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .content {
    width: px2rem(250);
    height: 100%;
  }

  .btn-wrap {
    height: 100%;
    background: #37332c;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .btn {
    width: px2rem(72);
    height: px2rem(28);
    background: #F0830F;
  }
}
</style>